import {DividendsService} from "app/dividends/service/DividendsService";
import {DividendsStore} from "app/dividends/store/DividendsStore";

import Pipes from "./pipes";

const moduleName = `tfApp.dividends`;

export default angular.module(moduleName, [Pipes(moduleName)])
                      .service(DividendsService.id, DividendsService)
                      .service(DividendsStore.id, DividendsStore)
                      .name;
